import React from 'react';
import { RichLink } from '@root/src/web/components/RichLink';
import { DefaultRichLink } from '@root/src/web/components/DefaultRichLink';
import { useApi } from '@root/src/web/lib/api';
import { decideTheme } from '@root/src/web/lib/decideTheme';
import { Design, Display } from '@guardian/types';
const buildUrl = (element, ajaxUrl) => {
    const path = new URL(element.url).pathname;
    return `${ajaxUrl}/embed/card${path}.json?dcr=true`;
};
export const RichLinkComponent = ({ element, ajaxEndpoint, richLinkIndex, }) => {
    const url = buildUrl(element, ajaxEndpoint);
    const { data, loading, error } = useApi(url);
    if (error) {
        // Send the error to Sentry and then prevent the element from rendering
        window.guardian.modules.sentry.reportError(error, 'rich-link');
        return (React.createElement(DefaultRichLink, { index: richLinkIndex, headlineText: element.text, url: element.url }));
    }
    if (loading || !data) {
        // Only render once data is available
        return null;
    }
    return (React.createElement(RichLink, { richLinkIndex: richLinkIndex, cardStyle: data.cardStyle, thumbnailUrl: data.thumbnailUrl, headlineText: data.headline, contentType: data.contentType, url: data.url, starRating: data.starRating, format: {
            display: Display.Standard,
            design: Design.Article,
            theme: decideTheme({ pillar: data.pillar }),
        }, tags: data.tags, sponsorName: data.sponsorName, contributorImage: data.contributorImage }));
};
